<script setup>
import { watch, ref, onMounted } from 'vue';
import FvHeader from '../shared/header.vue';
import { axiosPost } from '../../Axios/post';
import LogExpandData from './log-expand-data.vue';
import { useFVStore } from '../../stores/formvibes';
import { storeToRefs } from 'pinia';

const store = useFVStore();
const { pageSizes } = storeToRefs(store);
const isLoading = ref(false);
const perPage = ref(10);
const currentPage = ref(1);
const tableData = ref([]);
const logCount = ref(0);
const selectedRow = ref('');
const isExpanded = ref(false);

const handleSizeChange = (val) => {
    perPage.value = parseInt(val);
}
const i18n = window.fvGlobalVar?.i18n;

const handleCurrentChange = (val) => {
    currentPage.value = parseInt(val);
}

watch([perPage, currentPage], () => {
    getEventLogData();
})
onMounted(() => {
    getEventLogData();
});
const isJsonString = (str) => {
	try {
		const json = JSON.parse(str);
		return typeof json === 'object';
	} catch (e) {
		return false;
	}
};
const getEventLogData = async () => {
    isLoading.value = true;
    const {
			data: { count, data: eventLogsData },
		} = await getData();
        logCount.value = parseInt(count);
    const data = eventLogsData.map((d) => {
            let { description, event } = d;
            if (isJsonString(d.description) && event === 'edit-data') {
                const parsedDescription = JSON.parse(d.description);
                description = `Entry ID: ${parsedDescription.entry_id},${i18n?.field_name}: ${parsedDescription.field_name}
                ${parsedDescription.value.prev_value} => ${parsedDescription.value.next_value}`;
            }
            return {
                ...d,
                description,
                event,
            };
        });
    tableData.value = data;

    isLoading.value = false;
}

const getData = async () => {
    const page = currentPage.value;
    const pageSize = perPage.value;

    const res = await axiosPost({
		action: 'fv_event_logs',
		queryParams: {
			page,
			pageSize,
		},
	});

    return res;
}
const rowClick = (row) => {
    selectedRow.value = row;
}
const closeExpand = () => {
    selectedRow.value = '';
}
watch(selectedRow,()=> {
    if(selectedRow.value){
        isExpanded.value = true;
    }
    else{
        isExpanded.value = false;
    }
})
</script>
<template>
    <el-config-provider>
        <div>
            <FvHeader />
            <div class="fv-content-wrapper">
                <div class="fv-page-title">
                    <h3>Event Log</h3>
                </div>
                <div class="fv-event-log-wrapper">
                    <el-table :data="tableData" @row-click="rowClick" v-loading="isLoading">
                        <el-table-column prop="serial_number" label="S/N" width="80" />
                        <el-table-column prop="user" label="User" width="180" />
                        <el-table-column prop="event" label="Event" width="180" />
                        <el-table-column prop="description" label="Description" />
                        <el-table-column prop="export_time_gmt" label="Time" width="200" />
                    </el-table>
                    <div class="fv-table-pagination">
                        <el-pagination
                            class="fv-pagination"
                            layout="total, sizes, prev, pager, next" 
                            :total="logCount"
                            :current-page="currentPage"
                            :page-sizes="pageSizes" 
                            :page-size="perPage"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            background
                        />
                    </div>
                </div>
            </div>
            <LogExpandData :row="selectedRow" :closeExpand="closeExpand" v-if="isExpanded" />
        </div>
    </el-config-provider>
</template>